/* file description */

import React, { useEffect, useState, useRef } from 'react';
import { Button, Space, message, Drawer, Modal } from 'antd';
import { ButtonLayout } from '@/asset/AssetTask/templates/Cascade/components';
import { ModuleInfo } from '@/common/model-apis/type';
import { CloseOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import SpQiankun from '@/components/sp-qiankun';
import { getPrimaryKeyOfModule } from '@/utils';
import { delAssetDataList } from '@/api/cascade';
import useMetaStore from '@/store/useMetaStore';

const { confirm } = Modal;


interface HeadDeleteButtonType {
  taskId: string;
  selectedRows: any[];
  tableWithRef: any;
  optionsActionType: string;
  setSelectedRows: (arg: any[]) => void;
  reload: () => void;
  moduleInfo?: ModuleInfo;
}

const HeadDeleteButton: React.FC<HeadDeleteButtonType> = function (props) {
  const [open, setOpen] = useState(false);
  const [targetUrl, setTargetUrl] = useState('');
  const { taskId, selectedRows, tableWithRef, optionsActionType, moduleInfo, setSelectedRows } = props;
  const meta = useMetaStore();

  const delTableItem = async () => {
    if (!selectedRows || selectedRows.length === 0) {
      message.warning('请选中行进行删除');
      return;
    }
    confirm({
      title: `已选择${selectedRows.length}条数据，您确定要批量删除？`,
      icon: <ExclamationCircleFilled />,
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      async onOk() {
        const idList = selectedRows?.map((row) => {
          return row?._id;
        });
        const delName = getPrimaryKeyOfModule(moduleInfo);
        const delResult = await delAssetDataList({
          delName,
          ns: moduleInfo?.namespaceHandle,
          module: moduleInfo?.handle,
          idList,
        });
        if (delResult.success) {
          message.success('删除成功');
          // fix jira SPZN-9229
          tableWithRef.current.reload();
          // 清除选中项缓存数据
          setSelectedRows([]);
          return;
        }
        message.error('删除失败');
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };


  return (
    <ButtonLayout type="danger" onClick={delTableItem}>
      批量删除
    </ButtonLayout>
  );
};

export default HeadDeleteButton;
